import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { APPLICATION_INSIGHTS_CONNECTION_STRING } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AppInsightsService {
    private _appInsights?: ApplicationInsights;

    public initialize(): void {
        try {
            if (APPLICATION_INSIGHTS_CONNECTION_STRING) {
                this._appInsights = new ApplicationInsights({
                    config: {
                        connectionString: APPLICATION_INSIGHTS_CONNECTION_STRING
                    }
                });
                this._appInsights.loadAppInsights();
                this._appInsights.trackPageView();
            }
        } catch (e) {
            console.error('Application Insights failed to start ' + e);
            this._appInsights = undefined;
        }
    }

    public trackException(exception: Error): void {
        this._appInsights?.trackException({
            exception: exception
        });
    }
}
